
(function(){
  try{
    var tz  = (Intl.DateTimeFormat().resolvedOptions().timeZone || '').toLowerCase();
    var off = (new Date()).getTimezoneOffset(); // IST = -330
    var isIN = tz.indexOf('kolkata') > -1 || tz.indexOf('calcutta') > -1 || off === -330;

    function toggle(){
      var w = document.getElementById('rafaq-widget');
      if (!w) return false;
      w.style.display = isIN ? 'block' : 'none';
      return true;
    }

    if (!toggle() && 'MutationObserver' in window){
      var mo = new MutationObserver(function(){
        if (toggle()) mo.disconnect();
      });
      mo.observe(document.documentElement, { childList:true, subtree:true });
    }
  }catch(e){}
})();




(function(){
  try {
    var tz  = (Intl.DateTimeFormat().resolvedOptions().timeZone || '').toLowerCase();
    var off = (new Date()).getTimezoneOffset(); // IST=-330, UAE=-240

    // Define regions
    window.regionMap = {
      uae: {
        classes: ['uae-only'],
        zones:   ['asia/dubai','asia/muscat'],
        offsets: [-240]
      },
      india: {
        classes: ['india-only'],
        zones:   ['asia/kolkata','asia/calcutta'],
        offsets: [-330]
      }
    };

    window.activeRegions = {};

    function showFor(key){
      var cfg = window.regionMap[key], i, matchZone=false, matchOff=false;
      for (i=0;i<cfg.zones.length;i++)   { if (tz.indexOf(cfg.zones[i]) > -1) { matchZone = true; break; } }
      for (i=0;i<cfg.offsets.length;i++) { if (off === cfg.offsets[i])        { matchOff  = true; break; } }
      if (matchZone || matchOff){
        window.activeRegions[key] = true;
        for (i=0;i<cfg.classes.length;i++){
          var nodes = document.getElementsByClassName(cfg.classes[i]);
          for (var j=0;j<nodes.length;j++){ nodes[j].style.display = 'block'; }
        }
        return true;
      }
      return false;
    }

    // Run checks
    var isIN  = showFor('india');
    var isUAE = showFor('uae');

    // Show global-only if NOT India and NOT UAE
    if (!isIN && !isUAE) {
      var nodes = document.getElementsByClassName('global-only');
      for (var j=0;j<nodes.length;j++){ nodes[j].style.display = 'block'; }
    }

  } catch(e){}
})();

